import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localePath } from "@/i18n/localePath";

export function useKeyboardShortcuts() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Don't trigger in inputs
      const tag = (e.target as HTMLElement).tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;

      // Normalise path by stripping locale prefix
      const cleanPath = location.pathname.replace(/^\/(ru|es)/, "").replace(/^$/, "/");

      // Esc — close settings/journal → back to chat
      if (e.key === "Escape") {
        if (cleanPath === "/app/settings" || cleanPath === "/app/journal") {
          e.preventDefault();
          navigate(localePath("/app/chat", i18n.language));
        }
        return;
      }

      // Ctrl/Cmd shortcuts
      if (e.ctrlKey || e.metaKey) {
        if (e.key === ",") {
          e.preventDefault();
          navigate(localePath("/app/settings", i18n.language));
        } else if (e.key === "j" || e.key === "J") {
          e.preventDefault();
          navigate(localePath("/app/journal", i18n.language));
        } else if (e.key === "k" || e.key === "K") {
          e.preventDefault();
          // Focus chat input
          const input = document.querySelector("textarea") as HTMLTextAreaElement;
          input?.focus();
        }
      }

      // "/" to focus chat input (only on chat page)
      if (e.key === "/" && cleanPath === "/app/chat") {
        e.preventDefault();
        const input = document.querySelector("textarea") as HTMLTextAreaElement;
        input?.focus();
      }
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [navigate, location.pathname, i18n.language]);
}
